import type { ReplaceTestIdWithAppOne } from '../../const/testIds';

import { AppBaseIcon, type AppBaseIconProps } from './components/AppBaseIcon';
import { AppIconBackground } from './components/AppIconBackground';

export type AppIconProps = {
	hasIconBackground?: boolean;
} & ReplaceTestIdWithAppOne<AppBaseIconProps>;

export const AppIcon = ({ hasIconBackground, ...props }: AppIconProps) => {
	if (hasIconBackground) {
		return (
			<AppIconBackground>
				<AppBaseIcon {...props} />
			</AppIconBackground>
		);
	}

	return <AppBaseIcon {...props} />;
};
